import React from 'react'
import { Link } from 'react-router-dom';

import aboutImg1 from '../img/about/about-square-12.webp';
import heroImg from '../img/hero.jpg';

function About() {
  return (
    <section id="about" className="about section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6" data-aos="zoom-out" data-aos-delay="200">
              <div className="about-image position-relative">
                <img
                  src={heroImg}
                  alt="About Our Consulting Firm"
                  className="img-fluid main-image"
                />
                <div className="experience-badge position-absolute">
                  <span className="years">15+</span>
                  <span className="text">Years of Experience</span>
                </div>
              </div>
            </div>

            <div className="col-lg-6" data-aos="fade-left" data-aos-delay="300">
              <div className="about-content">
                <h2>We Help Businesses Reach Their Full Potential</h2>
                <p>
                  The company provides reliable, turnkey power solutions with a focus on quality, innovation, and sustainable growth
                </p>

                <div className="row features-row">
                  {[
                    ['bi-graph-up-arrow', 'Business Growth'],
                    ['bi-lightbulb', 'Innovative Solutions'],
                    ['bi-people', 'Expert Team'],
                    ['bi-trophy', 'Proven Results'],
                  ].map(([icon, title], idx) => (
                    <div className="col-md-6" key={idx}>
                      <div className="feature-item">
                        <div className="icon">
                          <i className={`bi ${icon}`}></i>
                        </div>
                        <h4>{title}</h4>
                        
                      </div>
                    </div>
                  ))}
                </div>

                <div className="cta-button">
                  <Link to="/about" className="btn btn-primary">
                    Learn More About Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  )
}

export default About